import { render, staticRenderFns } from "./customerRoster.vue?vue&type=template&id=f6461cb2&scoped=true&"
import script from "./customerRoster.vue?vue&type=script&lang=js&"
export * from "./customerRoster.vue?vue&type=script&lang=js&"
import style0 from "./customerRoster.vue?vue&type=style&index=0&id=f6461cb2&prod&scoped=true&lang=css&"
import style1 from "./customerRoster.vue?vue&type=style&index=1&id=f6461cb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6461cb2",
  null
  
)

export default component.exports